<template>
<div class="yjui-mian">
    <div class="loading k-square-holder2" v-if="state == 'loading'">
            <div class="k-square4 k-square4a"></div>
            <div class="k-square4 k-square4b"></div>
            <div class="k-square4 k-square4c"></div>
            <div class="k-square4 k-square4d"></div>
    </div>
    <div class="loading" v-else-if="state == 'empty'">

    </div>
    <div class="loading" v-else-if="state == 'error'">

    </div>
    
    <slot class="loading" v-else-if="state == 'content'"></slot>
</div>
</template>
<script>
export default {
     name: 'BasePage',
     props: {
       state: {
            type: String
       },
       message: {
            type: String
       }
    },
    data: function(){
      return {
          
      }
    },
    methods: {

    },
 
}
</script>
<style scoped>

.loading{ position:absolute;top: 50%; left: 50%; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%); width: 50px;  }
.k-square4 {
	display:inline-block;
	width:15px;
	height:15px;
	background:#000;
	opacity:1;
	animation:k-loadingR 2.0s infinite;
	opacity:0;
}
.k-square4b {
	animation-delay:.5s
}
.k-square4c {
	animation-delay:1.5s
}
.k-square4d {
	animation-delay:1s
}
@keyframes k-loadingR {
	0% {
	opacity:.5;
	background:#000
}
30% {
	opacity:.5;
	background:#666
}
60% {
	opacity:0
}
75% {
	opacity:0
}
100% {
	opacity:.5;
	background:#000
}
}@keyframes k-loadingS {
	40% {
	transform:translateX(0);
	opacity:.8
}
100% {
	transform:translateX(300px);
	opacity:0
}
}
</style>



// WEBPACK FOOTER //
// src/components/BasePage/basepage.vue